module.exports = __webpack_public_path__ + "static/media/point-marker-dummy.8ed61905.svg";